enum TimeUnits {
  milliseconds,
  seconds,
  minutes,
  hours,
  days
}

export default TimeUnits;